<template>
  <aw-spinner />
</template>

<script setup lang="ts">
  import { onMounted } from 'vue';
  import { navigateTo, useAsyncData, useNuxtApp, useRoute } from 'nuxt/app';
  import { fetchKey } from '~~/common/utils/awRunLegacyAsyncData';
  import { getLocaleCodeForUrl } from '~~/common/utils/localeCode';
  import type { Schema } from '~~/common/types/api';
  import AwSpinner from '~~/common/components/Common/AwSpinner.vue';

  defineOptions({
    name: 'SimpleGiftCardOrderPayPaymentReturn',
  });

  const { $i18n, $api, $logger, $localePath } = useNuxtApp();
  const route = useRoute();

  const { data } = await useAsyncData(
    fetchKey(),
    async () => {
      try {
        const result = await $api.$post<Schema<'PaymentReturnModel.PaymentReturnOutputModel'>>('/payment_return', {
          transactionNumber: route.query.trId,
        });
        return {
          orderIdent: result.orderIdent,
        };
      } catch (e) {
        $logger.error(e);
        return {
          orderIdent: null,
        };
      }
    },
    {
      default: () => ({ orderIdent: null }),
    },
  );

  if (!data.value?.orderIdent) {
    await navigateTo(`/${getLocaleCodeForUrl({ $i18n })}`);
  }

  onMounted(() => {
    if (data.value?.orderIdent) {
      navigateTo({
        path: $localePath(`/gift-card-order-success/${data.value.orderIdent}`),
      });
    }
  });
</script>
